module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bloc d-bloc",
    class: {
      'bgc-tangerine-yellow': _vm.color, 'bgc-white-smoke': !_vm.color
    }
  }, [_c('div', {
    staticClass: "container bloc-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', {
    staticClass: "m-t-05 m-b-1 tc-midnight-blue"
  }, [_vm._t("header")], 2), _vm._v(" "), _vm._t("subheader")], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "m-t-05"
  }, [_vm._t("right-col")], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7c196462"}!./src/app/components/subheader/subheader.html
// module id = 493
// module chunks = 1